<div *ngIf="currentBanner && currentBanner.customColor"
  class="custom-banner"
  [style.background-color]="currentBanner.customColor">
  <span class="custom-banner-message">{{ currentBanner.message }}</span>
  <button class="custom-banner-close" (click)="onDismiss()" aria-label="Close">&#x2715;</button>
</div>

<prism-banner
  *ngIf="currentBanner && !currentBanner.customColor"
  #banner
  [variant]="currentBanner.variant || 'toast'"
  [tone]="currentBanner.tone || 'info'"
  [dismissible]="currentBanner.dismissible !== false"
  [auto-dismiss]="false"
  (prism-close)="onDismiss()">
  {{ currentBanner.message }}
</prism-banner>
